module.exports = __webpack_public_path__ + "img/cover-1.896fb2b5.jpg";